import General from './General.vue';

export default General;



// WEBPACK FOOTER //
// ./src/pages/profile/views/general/index.ts